function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import Link from 'shared/components/Link';
import Popover from 'researcher/components/Popover';
import Redirect from 'shared/components/Redirect';
import useArchiveEntity, { ConfirmArchiveModal } from 'researcher/hooks/use-archive-entity';
import useRepeater from 'researcher/hooks/use-repeater';
import { T } from 'shared/helper/translate';
import { NUMBER_OF_SECONDS_BETWEEN_UPDATES } from '../constants';
import DigitalEditingHeader from './DigitalEditingHeader';
var DigitalEditDetails = function DigitalEditDetails(_ref) {
  var accessType = _ref.accessType,
    archiveDigitalEdit = _ref.archiveDigitalEdit,
    digitalEdit = _ref.digitalEdit,
    digitalEditIdentity = _ref.digitalEditIdentity,
    getDownloadUrl = _ref.getDownloadUrl,
    previousUrl = _ref.previousUrl,
    searchDigitalEdits = _ref.searchDigitalEdits,
    status = _ref.status,
    updateDisplayedDigitalEdits = _ref.updateDisplayedDigitalEdits;
  var downloading = status.retrievingDownload && status.downloadingFiles.indexOf(digitalEdit.identity) >= 0;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    redirect = _useState2[0],
    setRedirect = _useState2[1];
  var _useArchiveEntity = useArchiveEntity({
      archiveEntity: archiveDigitalEdit,
      callback: function callback() {
        setRedirect(previousUrl);
      }
    }),
    descriptor = _useArchiveEntity.descriptor,
    handleArchive = _useArchiveEntity.handleArchive,
    showConfirm = _useArchiveEntity.showConfirm,
    toggleShowConfirm = _useArchiveEntity.toggleShowConfirm;
  var _useRepeater = useRepeater({
      fn: function fn() {
        return updateDisplayedDigitalEdits([digitalEdit.identity]);
      },
      numberOfSecondsBetweenCalls: NUMBER_OF_SECONDS_BETWEEN_UPDATES
    }),
    startUpdating = _useRepeater.start,
    stopUpdating = _useRepeater.stop;
  useEffect(function () {
    if (digitalEdit) {
      startUpdating();
    } else {
      searchDigitalEdits({
        identities: [digitalEditIdentity]
      }).then(function (digitalEdits) {
        if (digitalEdits.length === 0) {
          setRedirect('/researcher/digital-editing');
        } else {
          startUpdating();
        }
      });
    }
    return function () {
      return stopUpdating();
    };
  }, []);
  return redirect ? /*#__PURE__*/React.createElement(Redirect, {
    to: redirect
  }) : /*#__PURE__*/React.createElement("div", {
    className: "container digital-edits"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 col-12"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    bodyClassName: "bg-gray-lighter",
    title: "Digital editing"
  }), /*#__PURE__*/React.createElement(DigitalEditingHeader, {
    accessType: accessType,
    busy: status.searchBusy
  }), /*#__PURE__*/React.createElement("h3", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Your digital edits"
  })), /*#__PURE__*/React.createElement(Link, {
    to: previousUrl
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-circle-arrow-left"
  }), " ", /*#__PURE__*/React.createElement(T, {
    source: "Back to recent edits"
  })), digitalEdit ? /*#__PURE__*/React.createElement("div", {
    className: "bg-light border mt-3 digital-edit-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-3 pt-3"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-truncate"
  }, digitalEdit.file.name), /*#__PURE__*/React.createElement("div", null, downloading ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary float-end",
    onClick: function onClick() {}
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "me-2",
    "aria-hidden": "true",
    spin: true
  }), /*#__PURE__*/React.createElement(T, {
    source: "Downloading..."
  })) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary float-end",
    onClick: function onClick() {
      return getDownloadUrl(digitalEdit.identity, digitalEdit.file.name);
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-2",
    icon: "fa-solid fa-download",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Download edited manuscript"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-muted file-details mt-2"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-2 float-start",
    icon: "fa-solid fa-file-lines"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(T, {
    source: digitalEdit.fileType
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(T, {
    source: "Uploaded %(date)s",
    params: {
      date: digitalEdit.createdAt
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "d-block pb-2 text-primary",
    onClick: function onClick() {
      return toggleShowConfirm(digitalEdit.identity, digitalEdit.file.name);
    }
  }, /*#__PURE__*/React.createElement(Popover, {
    content: "de-delete-file-tooltip"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-1",
    icon: "fa-solid fa-trash",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(T, {
    source: "delete"
  })))))), /*#__PURE__*/React.createElement("h6", {
    className: "h3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "About automated English language editing"
  })), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "automated-edit-details"
  }))), /*#__PURE__*/React.createElement("h6", {
    className: "h3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Suggested next steps"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "next-steps"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step clearfix px-3 py-1"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "float-start",
    icon: "fa-solid fa-pencil-square"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(T.md, {
    source: "professional-editing-next-step",
    params: {
      url: '/researcher/submit/select'
    }
  }), /*#__PURE__*/React.createElement(Link, {
    target: "_blank",
    rel: "noopener noreferrer",
    to: "/researcher/submit/select",
    className: "pull-right btn btn-success mt-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Get editing"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "step clearfix px-3 py-1"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "float-start",
    icon: "fa-solid fa-bullhorn"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(T.md, {
    source: "preprint-next-step",
    params: {
      url: 'https://www.researchsquare.com/researchers/preprints'
    },
    linkRenderer: function linkRenderer(_ref2) {
      var href = _ref2.href,
        children = _ref2.children;
      return /*#__PURE__*/React.createElement("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer"
      }, children);
    }
  }), /*#__PURE__*/React.createElement("a", {
    href: "https://www.researchsquare.com/researchers/preprints",
    className: "pull-right btn btn-success mt-0 mb-2",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Learn more"
  })))))) : /*#__PURE__*/React.createElement("div", {
    className: "bg-light border p-3 mt-3 text-muted"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Loading"
  }), " ", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  })))), /*#__PURE__*/React.createElement(ConfirmArchiveModal, {
    descriptor: descriptor,
    handleArchive: handleArchive,
    showConfirm: showConfirm,
    toggleShowConfirm: toggleShowConfirm,
    terms: {
      confirmation: 'de-delete-file-confirmation',
      description: 'de-delete-file-desc',
      title: 'de-delete-file-title',
      yesText: 'de-delete-file-yes-text'
    }
  }));
};
export default DigitalEditDetails;